module.exports = __webpack_public_path__ + "static/media/image12.c1c9c17f.png";